import React, { useState } from 'react';
import { Box } from '@mui/material';
import { EditTeamForm } from '@components';
import { IconButtonV2, EditIcon } from 'components/common/ui';
import { ModalV2, Tooltip } from 'components/common/modals';
import { useToggleModal } from '@hooks';
import { teamsServices } from '@services';
import { showError } from '@utils';

const EditTeamModal = ({ agents, roles, team, onGetTeam }) => {
  const { isOpen, handleClose, handleOpen } = useToggleModal();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const {
    id: teamId,
    name: teamName,
    membersByName,
    membersByRole,
    emailSignature,
    active,
  } = team;

  const getPayload = (form) => {
    const byRole = form?.membersByRole?.map((role) => role?.value);
    const byName = form?.membersByName?.map((name) => name?.value);
    return {
      members: [...byRole, ...byName],
      active: form?.active,
      emailSignature: form?.emailSignature,
    };
  };

  const handleSubmit = async (form) => {
    const payload = getPayload(form);
    try {
      setIsSubmitting(true);
      await teamsServices.editTeamById(teamId, payload);
      await onGetTeam();
      handleClose();
    } catch (error) {
      showError(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <IconButtonV2
        variant="text"
        size="small"
        disabled={isSubmitting}
        onClick={handleOpen}
      >
        <Tooltip title="Edit Team" placement="top">
          <Box component="span" sx={{ display: 'flex', mb: '2px' }}>
            <EditIcon />
          </Box>
        </Tooltip>
      </IconButtonV2>
      <ModalV2
        id="edit-team-modal"
        title={`Edit Team ${teamName}`}
        isOpen={isOpen}
        isLoading={isSubmitting}
        onClose={handleClose}
        maxWidth="sm"
      >
        <EditTeamForm
          defaultValues={{
            membersByRole,
            membersByName,
            active,
            emailSignature,
          }}
          agents={agents}
          roles={roles}
          onSubmit={handleSubmit}
          onClose={handleClose}
          isSubmitting={isSubmitting}
          onGetTeam={onGetTeam}
        />
      </ModalV2>
    </>
  );
};

const memoizedEditTeamModal = React.memo(EditTeamModal);
export { memoizedEditTeamModal as EditTeamModal };

export default memoizedEditTeamModal;
